import React, { useState } from "react";
import { RentalStatus } from "../../constants/rentalItem";
import { PrimaryButton } from "../buttons/PrimaryButton";
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { UserBadge } from "../common/UserBadge";

export const ActiveRentalStatusCardSkeleton: React.FC = () => {

    return (
        <div className="rounded-lg shadow-main p-5">
            <div className="flex flex-row">
                <div className="skeleton_shine w-[150px] h-[150px] rounded-xl flex-none"></div>
                <div className="flex flex-row flex-grow w-full items-start ml-5 flex-wrap">
                    <div className="flex flex-row flex-grow items-start w-full pt-4 gap-10">
                        <div className="flex flex-col gap-2 basis-1/3 text-left">
                            <h2 className="skeleton_shine rounded-xl w-full h-6 pb-1"></h2>
                            <div className="flex flex-row pb-1">
                                <div className="skeleton_shine w-[100px] h-4 rounded-xl"></div>
                                
                            </div>
                            <div className="skeleton_shine rounded-xl w-[200px] h-10 text-left pt-2 flex flex-row gap-2 justify-start">
                                </div>
                        </div>
                        <div className="basis-1/3 flex flex-col text-left">
                            <h4 className="skeleton_shine rounded-xl w-[100px] h-6 mb-2"></h4>
                            <div className="flex flex-row gap-2 items-center">
                                <div className="skeleton_shine h-[50px] w-[50px] rounded-full"></div>
                                <div className="skeleton_shine rounded-xl h-4 w-[140px] pl-2"></div>
                            </div>
                            <div className="flex flex-col gap-2">
                                <div className="skeleton_shine rounded-xl w-[80px] h-4 flex flex-row items-center mt-2">
                                
                            </div>
                            <div className="skeleton_shine rounded-xl w-[200px] h-4 flex flex-row items-center">
                                
                            </div>
                            </div>
                            
                        </div>

                        <div className="basis-1/3 flex flex-col gap-2 text-start mt-3 lg:mt-0 ml-auto items-end">
                            <div className="skeleton_shine rounded-xl h-[100px] flex flex-col gap-3 w-[200px]">
                                
                            </div>

                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}